<template>
  <tvu-top-header
    :projectName="$t('lang.title')"
    :globalFunList="activateFunList"
    :languageSwitcher="isActivate ? {} : { type: 'dropdown' }"
    ref="tvuccHeader"
    @callback="topHeaderCallback">
    <template #top-header-version>
      <div>{{ version }}</div>
    </template>
    <template #top-header-middle>
      <div
        class="serviceSetting"
        v-if="!isActivate">
        <a
          class="backBtn"
          :href="switchUrl">{{ $t('lang.BackStr') }}</a>
        <span
          class="iconfont icon-shezhi1"
          :title="$t('lang.TSetting')"
          @click.stop="goToPage({dataMark: 'st'})"></span>
      </div>
    </template>
    <template #account-center-module>
      <div
        class="switchSupport"
        v-if="supportViewAccount && supportViewAccount !== ''"
        @click="logout('changeToSupport')">
        <span><i class="iconfont">&#xe6cf;</i>{{$t('lang.switchTo')}} : {{supportViewAccount.supportUserEmail}}</span>
      </div>
    </template>
  </tvu-top-header>
</template>
<script>
import Vue from 'vue'
import { TopHeader, TvuNotification } from 'tvu-common-ui'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import Tool from '@/assets/js/utils'
import { jumpLoginPage } from '@/assets/js/jumpLogin.js'

// 常量定义
const CONSTANTS = {
  DEFAULT_ALERT_TIMER: 30 * 1000, // 默认告警定时器间隔（毫秒）
  DEFAULT_GRID_TIMER: 30 * 1000, // 默认Grid通知定时器间隔（毫秒）
  RANDOM_TIMER_RANGE: { min: 1000, max: 9000 }, // 随机定时器范围
  BATTERY_CHECK_INTERVAL: 60000, // 电池检查间隔（毫秒）
  ERROR_CHECK_INTERVAL: 60000, // 错误率检查间隔（毫秒）
  INITIAL_DELAY: 1000, // 初始延迟（毫秒）
  MAX_RETRY_COUNT: 10, // 最大重试次数
  AUTO_CLEAR_DURATION: 10000, // 自动清除持续时间（毫秒）
  SOURCE_PARAM_INTERVAL: 2000, // 源参数更新间隔（毫秒）
  GRID_NUM_CHECK_INTERVAL: 1000, // Grid数量检查间隔（毫秒）
  ADD_NO_READ_ICON_RETRY_DELAY: 600 // 添加未读图标重试延迟（毫秒）
}

export default {
  name: 'HeaderCc',
  props: ['height', 'background'],
  components: {
    TvuTopHeader: TopHeader
    // SettingOperate
  },
  data () {
    return {
      activeIndex: '1',
      menuList: [],
      headerCss: {
        height: this.height || 64,
        zoom: 0
      },
      langOps: {
        height: 28,
        width: 110,
        color: '#fff'
      },
      localLanguage: navigator.language,
      setGridNumTimer: null, // 向Grid标签添加数量显示的定时器
      more10S: 1, // 超过最大重试次数清除定时器
      supportViewAccount: null, // 这个数组有数据代表,是support通过setting页面monitor操作用户跳转过来的 =>
      alertTime: 1,
      setAlertNumTimer: null, // 向Grid标签添加数量显示的定时器cc-ms-dev.tvunetworks.com/user-group 10.12.22.24:8081
      switchUrl: '',
      topBarFunList: ['account', 'helpCenter', 'headerTime'],
      deviceInfoTimerOut: null,
      lowBatterySoundObj: null,
      lowBatteryPeerIds: [],
      lowBatteryList: [],
      paramTimer: null
      // $tvuNotification: null
    }
  },
  computed: {
    isActivate () {
      return this.$route && this.$route.path === '/activate'
    },
    activateFunList () {
      return this.isActivate ? [] : this.topBarFunList
    },
    ...mapState({
      StateObj: state => state,
      pageRequest: state => state.websocket.pageRequest,
      pageRWebsocket: state => state.websocket.pageRWebsocket,
      pageSerBusRequest: state => state.websocket.pageSerBusRequest,
      featureFlag: state => state.featureFlag,
      newuserserviceLoginUrl: state => state.common.baseUrl.newuserserviceLoginUrl,
      userEmail: state => state.common.baseUserInfo.email,
      errorNotify: state => state.featureFlag.errorNotify,
      lowBatteryNotify: state => state.featureFlag.lowBatteryNotify,
      lowBatteryAutoClear: state => state.featureFlag.lowBatteryAutoClear,
      lowBatteryPlaySound: state => state.featureFlag.lowBatteryPlaySound,
      deviceBattery: state => state.deviceBattery
    }),
    normalizedErrorNotify () {
      return this.errorNotify !== undefined ? this.errorNotify : false
    },
    normalizedLowBatteryNotify () {
      return this.lowBatteryNotify !== undefined ? this.lowBatteryNotify : false
    }
  },
  created () {
    if (!this.isActivate && !this.StateObj.common.baseUrl.useCdn && !this.topBarFunList.includes('waffle')) this.topBarFunList.unshift('waffle')

    this.switchUrl = `${window.location.protocol}//${this.StateObj.common.baseUrl.switchUrl}`
    this.getVersion()

    Bus.$on('updateAccountInfo', tag => { // 跳转后渲染新的用户数据
      if (tag && tag === 'updateAccount') {
        this.$nextTick(() => {
          this.$refs.tvuccHeader.getCurrentAccountInfo()
        })
      }
      this.updateAccount()
    })
  },
  mounted () {
    Bus.$on('sourceId', data => { // 但获取到当前R的id的时候 创建websocket
      this.StateObj.selectRId = data && data.peerId
    })
    // 添加事件监听
    this._onDocumentClick = e => {
      if (e.target.classList.contains('notifyCloseItem') || e.target.closest('.notifyCloseItem')) {
        const listItem = e.target.closest('li')
        if (listItem) this.closeLi(listItem.classList[0])
      }
    }
    document.addEventListener('click', this._onDocumentClick)
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        this.addGridNotify()
        this.addStatusNotify()
        this.addAlertNotify()
      })
    } else {
      setTimeout(() => {
        this.addGridNotify()
        this.addStatusNotify()
        this.addAlertNotify()
      }, CONSTANTS.INITIAL_DELAY)
    }
  },
  watch: {
    normalizedErrorNotify: {
      handler (val, oldVal) {
        this.setBatteryAndError(val, oldVal, 'liveErrorRate')
      },
      immediate: true
    },
    normalizedLowBatteryNotify: {
      handler (val, oldVal) {
        this.setBatteryAndError(val, oldVal, 'battery')
      },
      immediate: true
    },
    // pageSerBusRequest 就绪时重新初始化 battery/error 通知（避免 WS 未就绪时 retry 耗尽后永久跳过）
    pageSerBusRequest (val, oldVal) {
      if (val && !oldVal) {
        this.setBatteryAndError(this.normalizedLowBatteryNotify, undefined, 'battery')
        this.setBatteryAndError(this.normalizedErrorNotify, undefined, 'liveErrorRate')
      }
    },
    // 监听websocket返回的device信息，用于实时更新设备电量信息
    deviceBattery: {
      handler (val) {
        this.updateBatteryInfo(val)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // Grid消息
    addGridNotify () {
      if (this.$createWebsocket.pageRequest) { // 新添加给grid导航标签添加正在请求数量显示的功能
        this.$createWebsocket.pageRequest('stop', 'getGridNotifyNum') // 停止websocket
      }
      this.pageRequest && this.pageRequest.send({
        message: {
          type: 'getGridNotifyNum',
          module: 'getGridNotifyNum',
          data: ''
        },
        time: 0,
        key: 'getGridNotifyNum',
        success: res => { // 第一次先发送一次websocket请求 获取初始数据
          if (this.$createWebsocket.pageRequest) { // 获取到数据之后,停止socket 以后都是30s获取一次
            this.$createWebsocket.pageRequest('stop', 'getGridNotifyNum') // 停止websocket
          }
          this.setNumber(res.result)
        }
      })
    },
    // alert消息
    addAlertNotify () {
      const timer = Number(this.StateObj.common.baseUrl?.getAlertMsgTimer || CONSTANTS.DEFAULT_ALERT_TIMER) +
        Math.floor(Math.random() * (CONSTANTS.RANDOM_TIMER_RANGE.max - CONSTANTS.RANDOM_TIMER_RANGE.min)) +
        CONSTANTS.RANDOM_TIMER_RANGE.min
      this.pageRequest && this.pageRequest.send({
        message: {
          type: 'alertMsg',
          module: 'alertMsg',
          data: ''
        },
        time: timer,
        key: 'alertMsg',
        success: res => {
          Bus.$emit('alertNotReadMsg', res.result.notReadMsg.length)
          this.addNoReadIcon(res.result.notReadMsg.length)
          if (!this.featureFlag.aleartMessage) return
          if (res.result.notReadMsg.length) {
            res.result.newMsg.map((v, i) => {
              setTimeout(() => {
                this.addTvuNotify({
                  title: v.title,
                  dangerouslyUseHTMLString: true,
                  offset: 120,
                  type: 'warning',
                  customClass: 'alert_message_box',
                  message: `<div><span>${this.$t('lang.from')}:</span><span>${v.sender_name}</span>`
                })
              }, i)
            })
          }
        }
      })
    },
    // 全局消息提醒
    addStatusNotify () {
      this.pageRequest && this.pageRequest.send({
        message: {
          type: 'deviceStatusChange',
          module: 'deviceStatusChange',
          data: ''
        },
        time: 0,
        isOnce: true,
        key: 'deviceStatusChange',
        success: res => {
          const data = res.result.device
          const oldStatus = res.result.oldStatus + ''
          const newStatus = res.result.newStatus + ''
          let msg
          let flag = false
          const title = data.name
          if (((oldStatus === '0' && newStatus === '1') || (oldStatus === '0' && newStatus === '2')) && this.featureFlag.onlineNotify) {
            msg = `${this.$t('lang.onlined')}`
            flag = true
          } else if (((oldStatus === '2' && newStatus === '0') || (oldStatus === '1' && newStatus === '0')) && this.featureFlag.offlineNotify) {
            msg = `${this.$t('lang.offlined')}`
            flag = true
          } else if (oldStatus === '1' && newStatus === '2') {
            msg = `${this.$t('lang.startLiveTip')}`
            if (!this.featureFlag.startTransmission) {
              flag = false
            } else {
              flag = true
            }
          } else if (oldStatus === '2' && newStatus === '1') {
            msg = `${this.$t('lang.stopLiveTip')}`
            if (!this.featureFlag.stopTransmission) {
              flag = false
            } else {
              flag = true
            }
          }
          if (flag) {
            this.addTvuNotify({
              title: title,
              message: msg,
              customClass: 'notifyGlobal ccNotifyStyle',
              offset: 120,
              duration: 5000
            })
          }
        }
      })
    },
    topHeaderCallback (obj) {
      if (obj.type === 'sessionExpired') {
        jumpLoginPage()
      }
      if (obj.type === 'signOut') {
        this.logout('logout')
      }
    },
    goToPage (item) {
      this.$router.push({ path: `/${item.dataMark}` }).catch(() => {})
    },
    /**
     * 转换名字，提取前两个字符
     * @param {string|*} name - 名字字符串或其他类型
     * @returns {string|*} 如果是字符串返回前两个字符，否则返回原值
     */
    TranslateName (name) {
      if (typeof name === 'string' && name.length > 0) {
        return name.substr(0, 2)
      }
      return name
    },
    /**
     * 获取开始/停止传输的告警参数
     * @param {string} v - 'stop' 表示停止，其他值表示开始
     * @returns {Object} 包含 pn 属性的参数对象
     */
    getStartStopAlert (v) {
      const params = {
        pn: v === 'stop' ? 'stopTransmission' : 'startTransmission'
      }
      return params
    },
    updateAccount () {
      try {
        const supportViewAccount = window.sessionStorage.getItem('userChangeInfo')
        if (supportViewAccount) {
          const parsed = JSON.parse(supportViewAccount)
          if (parsed) {
            this.supportViewAccount = parsed
            this.$nextTick(() => {
              if (this.$refs.logoutBtn) {
                this.$refs.logoutBtn.show()
              }
            })
            this.$forceUpdate()
            return
          }
        }
        // 如果没有数据或解析失败，隐藏按钮
        this.$nextTick(() => {
          if (this.$refs.logoutBtn) {
            this.$refs.logoutBtn.hide()
          }
        })
        this.supportViewAccount = null
      } catch (error) {
        console.error('Failed to parse userChangeInfo:', error)
        this.$nextTick(() => {
          if (this.$refs.logoutBtn) {
            this.$refs.logoutBtn.hide()
          }
        })
        this.supportViewAccount = null
      }
    },
    getVersion () {
      this.version = 'UI：' + window.localStorage.getItem('newCCVersion')
    },
    // 获取用户行为记录
    getUserBehavior (pn, remark) {
      const serverName = 'user'
      const params = { pn, remark, serverName }
      this.axios.get('/ccp/tvucc-user/userBehavior/get', {
        params: params
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$store.commit('SET_USER_BEHAVIORS', res.data.result ? res.data.result : {})
          Bus.$emit('isReturnUserBehaviors', true)
        }
      }).catch(() => {})
    },
    // 退出登入
    logout (options) {
      if (options === 'logout') {
        this.axios.get('/ccp/tvucc-user/user/logout').then(res => {
          const errorCode = res.data.errorCode
          if (errorCode === '0x0') {
            window.localStorage.setItem('NewCCsession3.0', '')
            window.sessionStorage.setItem('userChangeInfo', '')
            // Config-T会存入TSID，在登出时应该清空
            Tool.clearTSID()
            window.location.href = window.location.protocol + '//' + res.data.result.redirectUrl
          }
        }).catch(() => { })
      } else if (options === 'changeToSupport') {
        this.$confirm(this.$t('lang.gotoSupportTips'), '', {
          cancelButtonText: this.$t('lang.cancel'),
          confirmButtonText: this.$t('lang.i18n_confirm'),
          cancelButtonClass: 'btn-custom-cancel',
          type: 'warning',
          iconClass: 'myIcon'
        }).then(() => {
          Bus.$emit('clearMonitor')
        }).catch(() => {})
      }
    },
    // 设置Battery和Error信息
    setBatteryAndError (val, oldVal, type) {
      if (val && (val !== oldVal || !this.pageSerBusRequest || !this.pageSerBusRequest.sendMsgs[type])) {
        const configTime = type === 'battery'
          ? Number(this.$store.state?.common?.baseUrl?.batterySendTime) * 1000 || CONSTANTS.BATTERY_CHECK_INTERVAL
          : Number(this.$store.state?.common?.baseUrl?.errorRateSendTime) * 1000 || CONSTANTS.ERROR_CHECK_INTERVAL
        this.addDeviceInfoNotify(type, true, 0)
        setTimeout(() => {
          this.addDeviceInfoNotify(type, false, configTime)
        }, CONSTANTS.INITIAL_DELAY)
      } else if (!val && val !== oldVal) {
        this.setNotify([], type)
      }
    },
    // 设备电量及错误率提示
    addDeviceInfoNotify (type, isOnce, time, retryCount = 0) {
      // 这里开始初始化Audio
      if (type === 'battery' && this.lowBatteryPlaySound && !this.lowBatterySoundObj) {
        this.lowBatterySoundObj = new Audio(require('@/assets/audio/lowBattery.mp3'))
        this.lowBatterySoundObj.preload = 'auto'
      }
      if (!this.pageSerBusRequest) {
        if (retryCount >= CONSTANTS.MAX_RETRY_COUNT) return
        setTimeout(() => {
          this.addDeviceInfoNotify(type, isOnce, time, retryCount + 1)
        }, 500)
      } else {
        if (!isOnce) this.$createWebsocket.pageSerBusRequest && this.$createWebsocket.pageSerBusRequest('stop', type)
        this.pageSerBusRequest && this.pageSerBusRequest.send({
          message: {
            type: type,
            module: type,
            serverName: 'tvucc-alert',
            data: JSON.stringify({
              module: type,
              type: type,
              data: { userId: localStorage.getItem('userId') }
            })
          },
          time: time,
          isOnce: isOnce,
          key: type,
          success: res => {
            if ((res.module === 'battery' && this.featureFlag.lowBatteryNotify) || (res.module === 'liveErrorRate' && this.featureFlag.errorNotify)) {
              this.setNotify(res.result, res.module)
            }
          }
        })
      }
    },
    playPreloadedSound () {
      this.lowBatterySoundObj.currentTime = 0 // 重置播放位置
      this.lowBatterySoundObj.play().catch(e => console.log('播放失败:', e))
    },
    /**
     * 构建设备列表HTML
     * @param {Array} list - 设备列表
     * @param {string} module - 模块类型 ('battery' 或 'liveErrorRate')
     * @param {boolean} includeWrapper - 是否包含外层div包装
     * @returns {string} HTML字符串
     */
    buildDeviceListHTML (list, module, includeWrapper = false) {
      let listHTML = includeWrapper ? '<div class="deviceNotify"><ul>' : '<ul>'
      list.forEach(item => {
        const liContent = `<span>${item.name}</span>` +
          `${module === 'battery' ? '<span class="el-icon-close right notifyCloseItem" data-action="close"></span>' : ''} ` +
          `<span class="right red batteryInfo">${item.value}%</span>`
        listHTML += `<li class="device-${item.peerId}">${liContent}</li>`
      })
      listHTML += includeWrapper ? '</ul></div>' : '</ul>'
      return listHTML
    },
    setNotify (list, module) {
      const className = module === 'battery' ? 'batteryNotify' : 'errorNotify'
      const title = module === 'battery' ? `${this.$t('lang.batteryError')} <span class="notifyNum batteryNum">${list.length}</span>` : `${this.$t('lang.transmissionError')} <span class="notifyNum">${list.length}</span>`
      const MessageDom = document.getElementsByClassName(className)
      // 添加提示音
      if (module === 'battery') {
        if (this.lowBatteryPlaySound) {
          if (list.length && (!MessageDom || !MessageDom.length)) this.playPreloadedSound()
        }
        this.lowBatteryList = list
        this.updateSourceParam(list)
      }
      if ((!MessageDom || !MessageDom.length) && list.length) {
        const listHTML = this.buildDeviceListHTML(list, module, true)
        this.addTvuNotify({
          title: title,
          customClass: `deviceInfoTip ccNotifyStyle ${className}`,
          dangerouslyUseHTMLString: true,
          showToggle: true,
          message: listHTML,
          offset: 120,
          duration: module === 'battery' && this.lowBatteryAutoClear ? CONSTANTS.AUTO_CLEAR_DURATION : 0,
          onClose: () => {
            if (module === 'battery' && this.lowBatteryAutoClear) return
            this.setUserDeviceBatteryInfo(module, list)
          }
        })
      } else {
        if (list.length) {
          const listHTML = this.buildDeviceListHTML(list, module, false)
          const parentElement = document.getElementsByClassName(className)[0]
          const childTitle = parentElement.getElementsByClassName('notifyNum')[0]
          const childListBox = parentElement.getElementsByClassName('deviceNotify')[0]
          childListBox.innerHTML = listHTML
          childTitle.innerHTML = list.length
        } else {
          while (MessageDom.length > 0) {
            MessageDom[0].parentNode.removeChild(MessageDom[0])
          }
        }
      }
    },
    closeLi (peerId) {
      const item = this.lowBatteryList.filter(v => `device-${v.peerId}` === peerId)
      if (item.length) {
        this.setUserDeviceBatteryInfo('battery', item)
        const targetDom = document.querySelector(`.${peerId}`)
        targetDom?.remove()
        const batteryNumDom = document.querySelector('.batteryNum')
        if (batteryNumDom) {
          const batteryNum = Number(batteryNumDom.innerHTML) - 1
          if (batteryNum <= 0) {
            const MessageDom = document.querySelector('.batteryNotify')
            MessageDom?.remove()
          } else {
            batteryNumDom.innerHTML = batteryNum
          }
        }
      }
    },
    setUserDeviceBatteryInfo (module, list) {
      if (module !== 'battery') return
      const params = {
        pn: 'userDeviceBatteryInfo',
        content: JSON.stringify(list)
      }
      this.axios.post('/ccp/tvucc-user/userDevice/setPreference', params, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$set(this.featureFlag, 'userDeviceBatteryInfo', JSON.stringify(list))
        }
      }).catch(() => {})
    },
    // 当页面没有websocket时，需要添加
    addSourceDetailWs () {
      this.pageRequest && this.pageRequest.send({
        message: {
          type: 'detailInfo',
          module: 'detailInfo',
          data: { peerIds: this.lowBatteryPeerIds[0] }
        },
        time: CONSTANTS.INITIAL_DELAY,
        key: 'detailInfo',
        success: data => {
          // 用于低电量通知
          this.$store.commit('SET_DEVICE_BATTERY', data)
        }
      })
      this.updateSourceParam()
    },
    // 更新websocket需要的设备PeerId
    updateSourceParam () {
      this.paramTimer && clearInterval(this.paramTimer)
      if (!this.lowBatteryPeerIds.length) return
      this.paramTimer = setInterval(() => {
        if (!this.pageRequest.sendMsgs || this.pageRequest.sendMsgs && !this.pageRequest.sendMsgs.detailInfo) {
          this.paramTimer && clearInterval(this.paramTimer)
          this.addSourceDetailWs()
        }
        if (this.pageRequest.sendMsgs && this.pageRequest.sendMsgs.detailInfo) {
          const msgData = this.pageRequest.sendMsgs.detailInfo.message && this.pageRequest.sendMsgs.detailInfo.message.data
          if (msgData) {
            const ids = this.lowBatteryPeerIds
            const currentPeerId = msgData.peerIds
            let found = false
            for (let i = 0; i < ids.length; i++) {
              if (ids[i] === currentPeerId) {
                msgData.peerIds = ids[i + 1] ? ids[i + 1] : ids[0]
                found = true
                break
              }
            }
            if (!found && ids.length) msgData.peerIds = ids[0]
          }
        }
      }, CONSTANTS.SOURCE_PARAM_INTERVAL)
    },
    // 实时更新电量提示中的信息
    updateBatteryInfo (data) {
      if (!data) return
      if (Tool.isJSON(data.result)) {
        try {
          const deviceData = JSON.parse(data.result)[0]
          const targetPeerId = this.lowBatteryPeerIds.find(v => v === deviceData.peerId)

          if (targetPeerId) {
            // 处理电池数据
            let targetBattery = JSON.parse(deviceData.CurrentTPackBatteryRaw)
            const targetDom = document.querySelector(`.device-${targetPeerId}`)
            if (targetDom) {
              const batteryDom = targetDom?.querySelector('.batteryInfo')
              if (batteryDom) batteryDom.innerHTML = Number(targetBattery.BAT1VAL) + '%'
            }
          }
        } catch (error) {
          console.log('设备数据处理错误:', error)
        }
      }
    },
    // alert导航栏添加圆点
    addNoReadIcon (num) {
      if (document.querySelectorAll('nav .itemMenu').length === 0) {
        setTimeout(() => {
          this.addNoReadIcon(num)
        }, CONSTANTS.ADD_NO_READ_ICON_RETRY_DELAY)
        return
      }
      this.$store.commit('SET_MESSAGE_NUM', Number(num) ? Number(num) : 0)
    },
    setNumber (num) {
      this.setGridNumTimer = setInterval(() => { // 防止导航栏没有加载,设置定时器直到获取到导航栏/或达到最大重试次数为止
        if (this.more10S > CONSTANTS.MAX_RETRY_COUNT) {
          clearInterval(this.setGridNumTimer)
        }
        if (document.querySelectorAll('.itemMenu').length > 0) {
          this.handleGridNum(num)
        } else {
          this.more10S++
        }
      }, CONSTANTS.GRID_NUM_CHECK_INTERVAL)

      const timer = Number(this.StateObj.common.baseUrl?.getGridNotifyTimer || CONSTANTS.DEFAULT_GRID_TIMER) +
        Math.floor(Math.random() * (CONSTANTS.RANDOM_TIMER_RANGE.max - CONSTANTS.RANDOM_TIMER_RANGE.min)) +
        CONSTANTS.RANDOM_TIMER_RANGE.min
      this.pageRequest && this.pageRequest.send({
        message: {
          type: 'getGridNotifyNum',
          module: 'getGridNotifyNum',
          data: ''
        },
        time: timer,
        key: 'getGridNotifyNum',
        success: res => {
          this.handleGridNum(res.result)
        }
      })
    },
    handleGridNum (result) {
      const items = Array.from(document.querySelectorAll('.itemMenu'))
      items.forEach(item => {
        if (item.getAttribute('datakey') === 'gm') {
          const existGridNumber = item.querySelector('.gridNumber')
          const existGridNumberGrid = item.querySelector('.gridNumberGrid')
          if (existGridNumber) {
            existGridNumber.remove()
          } else if (existGridNumberGrid) {
            existGridNumberGrid.remove()
          }
          if (result > 0) {
            let positionClass = 'gridNumber'
            if (item.classList.contains('verticalTab')) {
              positionClass = 'gridNumberGrid'
            }
            const span = document.createElement('span')
            span.className = positionClass
            span.title = String(result)
            span.textContent = String(result)
            item.appendChild(span)
          }
          if (this.setGridNumTimer) {
            clearInterval(this.setGridNumTimer)
            this.setGridNumTimer = null
          }
        }
      })
    },
    addTvuNotify (obj) {
      if (!Vue.prototype.$tvuNotification) Vue.prototype.$tvuNotification = TvuNotification
      this.$tvuNotification(obj)
    },
    /**
     * 清除所有定时器
     * 统一管理定时器清理，避免内存泄漏
     */
    clearAllTimers () {
      const timers = [
        this.paramTimer,
        this.setGridNumTimer,
        this.setAlertNumTimer,
        this.deviceInfoTimerOut
      ]
      timers.forEach(timer => {
        if (timer) {
          clearInterval(timer)
          clearTimeout(timer)
        }
      })
      // 重置定时器引用
      this.paramTimer = null
      this.setGridNumTimer = null
      this.setAlertNumTimer = null
      this.deviceInfoTimerOut = null
    }
  },
  beforeDestroy () {
    // 使用统一的定时器清理方法
    this.clearAllTimers()
    // 停止 websocket 请求
    if (this.pageRequest) {
      this.pageRequest.stop('getGridNotifyNum')
      this.pageRequest.stop('deviceStatusChange')
      this.pageRequest.stop('alertMsg')
    }
    // 移除事件监听器
    document.removeEventListener('click', this._onDocumentClick)
    Bus.$off('initUserPreference')
    Bus.$off('updateAccountInfo')
  }
}
</script>
<style scoped lang="less">
.serviceSetting {
  position: relative;
  padding-right: 6px;
  &::after {
    content: '';
    width: 1px;
    height: 24px;
    display: block;
    background: #444;
    position: absolute;
    top: 8px;
    right: 0px;
  }
}
</style>
<style lang="less">
.alert_message_box.el-notification {
  background-color: #444;
  box-shadow: 0px 0px 15px #100400;
  border: none;
  .el-notification__icon.el-icon-warning {
    color: #dc4e39;
    font-size: 20px;
  }
  .el-notification__title,
  .el-notification__content,
  .el-notification__closeBtn.el-icon-close {
    color: #fff;
  }
  .el-notification__title {
    width: 250px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .el-notification__content {
    width: 250px;
    > p > div > span {
      float: left;
    }
    > p > div > span:nth-child(2) {
      width: 225px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
.alert_icon {
  position: absolute;
  top: 0;
  right: -20px;
  background-color: #f57c00;
  text-align: center;
  color: #fff;
  width: 19px;
  height: 19px;
  line-height: 19px;
  border-radius: 9.5px;
  padding: 0;
  font-size: 12px;
}
</style>
